export enum modalType{
    QR_CODE = "qr code",
    PRIVACY_POLICY = "privacy policy",
    SESSION_WARNING = "session warning",
    ON_EXIT="on exit"
}